import React from "react";
import { Box } from "@chakra-ui/react";

export function ActivityIcon() {
  return (
    <Box as="svg" xmlns="http://www.w3.org/2000/svg" boxSize="icon.xl" viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <Box
        as="path"
        fill="new.red.150"
        d="M128 216S28 160 28 92a52 52 0 0 1 100-20 52 52 0 0 1 100 20c0 68-100 124-100 124Z"
      />
      <Box
        as="path"
        fill="none"
        stroke="new.red.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={14}
        d="M32 128h40l16-24 32 48 16-24h24"
      />
      <Box
        as="path"
        d="M28.1 96c-.1-1.3-.1-2.7-.1-4a52 52 0 0 1 100-20h0a52 52 0 0 1 100 20c0 68-100 124-100 124s-39.9-22.4-69.3-56"
        fill="none"
        stroke="new.red.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={14}
      />
    </Box>
  );
}
